import React from 'react'

import { Box, SectionContainer, Text, Link, LazyBackgroundImage } from '@vividseats/vivid-ui-kit'

import { IMAGES, URLS } from '@/constants'

import QRCode from './components/qr-code'
import SendDownloadLink from './components/send-download-link'
import styles from './styles.module.scss'

const RewardHero: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            <SectionContainer className={styles.sectionContainer}>
                <Box className={styles.content}>
                    <Box className={styles.first}>
                        <Text as="h1" className={styles.title}>
                            Buy 10 tickets,
                            <br />
                            get the 11th on us*
                        </Text>
                        <Box desktopPaddingTop={3} tabletPaddingTop={4} mobilePaddingTop={0}>
                            <Text className={styles.subTitle}>
                                {'Shop and save in the Vivid Seats app.'}
                                <br />
                                {'Enter your number to get started.'}
                            </Text>
                            <Text className={styles.subTitleDesktop}>
                                Enroll in Vivid Seats Rewards to keep earning discounts, ticket upgrades, and perks with
                                every purchase. Just download our app to join.
                            </Text>
                        </Box>
                    </Box>
                    <Box className={styles.second} marginTop={7} marginBottom={8}>
                        {<SendDownloadLink />}
                        <Box className={styles.qrCodeContainer}>
                            <QRCode />
                        </Box>
                        <Box
                            display="flex"
                            justify="center"
                            mobileAlign="center"
                            paddingBottom={18}
                            className={styles.appStoreWrapper}
                        >
                            <Link className={styles.appStoreImage} href={URLS.APP_STORE_LINK} isExternal>
                                <LazyBackgroundImage url={IMAGES.REWARDS_APP_STORE} className={styles.appStoreImg} />
                            </Link>
                            <Link href={URLS.GOOGLE_PLAY_LINK} isExternal>
                                <LazyBackgroundImage url={IMAGES.REWARDS_GOOGLE_PLAY} className={styles.appStoreImg} />
                            </Link>
                        </Box>
                    </Box>
                    <Text size="xs" className={styles.legal}>
                        *Earn a Reward Credit equal to the average price of the 10 tickets, excluding taxes, fees, and
                        processing costs.
                    </Text>
                </Box>
            </SectionContainer>
        </div>
    )
}

export default RewardHero
